(function ($) {

    'use strict';

    window.bbb = window.bbb || {};

    const rscodes = {
        "0000": "Aceptado",
        "9001": "Error Interno",
        "9002": "Error genérico",
        "9003": "Error genérico",
        "9004": "Error genérico",
        "9005": "Error genérico",
        "9006": "Error genérico",
        "9007": "El mensaje de petición no es correcto, debe revisar el formato",
        "9008": "Falta Ds_Merchant_MerchantCode",
        "9009": "Error de formato en Ds_Merchant_MerchantCode",
        "9010": "Error falta Ds_Merchant_Terminal",
        "9011": "Error de formato en Ds_Merchant_Terminal",
        "9012": "Error genérico",
        "9013": "Error genérico",
        "9014": "Error de formato en Ds_Merchant_Order",
        "9015": "Error falta Ds_Merchant_Currency",
        "9016": "Error de formato en Ds_Merchant_Currency",
        "9018": "Falta Ds_Merchant_Amount",
        "9019": "Error de formato en Ds_Merchant_Amount",
        "9020": "Falta Ds_Merchant_MerchantSignature",
        "9021": "La Ds_Merchant_MerchantSignature viene vacía",
        "9022": "Error de formato en Ds_Merchant_TransactionType",
        "9023": "Ds_Merchant_TransactionType desconocido",
        "9024": "El Ds_Merchant_ConsumerLanguage tiene más de 3 posiciones",
        "9025": "Error de formato en Ds_Merchant_ConsumerLanguage",
        "9026": "Problema con la configuración",
        "9027": "Revisar la moneda que está enviando",
        "9028": "Error Comercio / terminal está dado de baja",
        "9029": "Que revise cómo está montando el mensaje",
        "9030": "Nos llega un tipo de operación errónea",
        "9031": "Nos está llegando un método de pago erróneo",
        "9032": "Revisar cómo está montando el mensaje para la devolución.",
        "9033": "El tipo de operación es erróneo",
        "9034": "Error interno",
        "9035": "Error interno al recuperar datos de sesión",
        "9037": "El número de teléfono no es válido",
        "9038": "Error genérico",
        "9039": "Error genérico",
        "9040": "El comercio tiene un error en la configuración, tienen que hablar con su entidad.",
        "9041": "Error en el cálculo de la firma",
        "9042": "Error en el cálculo de la firma",
        "9043": "Error genérico",
        "9044": "Error genérico",
        "9046": "Problema con la configuración del bin de la tarjeta",
        "9047": "Error genérico",
        "9048": "Error genérico",
        "9049": "Error genérico",
        "9050": "Error genérico",
        "9051": "Error número de pedido repetido",
        "9052": "Error genérico",
        "9053": "Error genérico",
        "9054": "No existe operación sobre la que realizar la devolución",
        "9055": "Existe más de un pago con el mismo número de pedido",
        "9056": "Revisar el estado de la autorización",
        "9057": "Que revise el importe que quiere devolver (supera el permitido)",
        "9058": "Que revise los datos con los que está validando la confirmación",
        "9059": "Revisar que existe esa operación",
        "9060": "Revisar que exista la confirmación",
        "9061": "Revisar el estado de la preautorización",
        "9062": "Que el comercio revise el importe a confirmar.",
        "9063": "Que el comercio revise el número de tarjeta que nos están enviando.",
        "9064": "Número de posiciones de la tarjeta incorrecto",
        "9065": "El número de tarjeta no es numérico",
        "9066": "Error mes de caducidad",
        "9067": "El mes de la caducidad no es numérico",
        "9068": "El mes de la caducidad no es válido",
        "9069": "Año de caducidad no válido",
        "9070": "El Año de la caducidad no es numérico",
        "9071": "Tarjeta caducada",
        "9072": "Operación no anulable",
        "9073": "Error en la anulación",
        "9074": "Falta Ds_Merchant_Order (Pedido)",
        "9075": "El comercio tiene que revisar cómo está enviando el número de pedido",
        "9076": "El comercio tiene que revisar el número de pedido",
        "9077": "El comercio tiene que revisar el número de pedido",
        "9078": "Por la configuración de los métodos de pago de su comercio no se permiten los pagos con esa tarjeta.",
        "9079": "Error genérico",
        "9080": "Error genérico",
        "9081": "Se ha perdido los datos de la sesión",
        "9082": "Error genérico",
        "9083": "Error genérico",
        "9088": "El comercio tiene que revisar el valor que envía en ese campo",
        "9089": "El valor de caducidad no ocupa 4 posiciones",
        "9092": "Se ha introducido una caducidad incorrecta.",
        "9093": "Denegación emisor",
        "9094": "Denegación emisor",
        "9095": "Denegación emisor",
        "9099": "Error al interpretar respuesta de autenticación",
        "9103": "Error al montar la petición de Autenticación",
        "9112": "Que revise que está enviando en el campo Ds_Merchant_Transacction_Type.",
        "9113": "Error interno",
        "9114": "Se está realizando la llamada por GET, la tiene que realizar por POST",
        "9115": "Que revise los datos de la operación que nos está enviando",
        "9116": "La operación sobre la que se desea pagar una cuota no es una operación válida",
        "9117": "La operación sobre la que se desea pagar una cuota no está autorizada",
        "9118": "Se ha excedido el importe total de las cuotas",
        "9119": "Valor del campo Ds_Merchant_DateFrecuency no válido (Pagos recurrentes)",
        "9120": "Valor del campo Ds_Merchant_ChargeExpiryDate no válido",
        "9121": "Valor del campo Ds_Merchant_SumTotal no válido",
        "9122": "Formato incorrecto del campo Ds_Merchant_DateFrecuency o Ds_Merchant_SumTotal",
        "9123": "Se ha excedido la fecha tope para realiza la Transacción",
        "9124": "No ha transcurrido la frecuencia mínima en un pago recurrente sucesivo",
        "9125": "Error genérico",
        "9126": "Operación Duplicada",
        "9127": "Error Interno",
        "9128": "Error interno",
        "9130": "Error Interno",
        "9131": "Error Interno",
        "9132": "La fecha de Confirmación de Autorización no puede superar en más de 7 días a la de Preautorización.",
        "9133": "La fecha de Confirmación de Autenticación no puede superar en más de 45 días a la de Autenticación Previa que el comercio revise la fecha de la Preautenticación",
        "9139": "Pago recurrente inicial está duplicado",
        "9140": "Error Interno",
        "9142": "Tiempo excedido para el pago",
        "9151": "Error Interno",
        "9169": "El valor del campo Ds_Merchant_MatchingData (Datos de Case) no es válido, que lo revise",
        "9170": "Que revise el adquirente que manda en el campo",
        "9171": "Que revise el CSB que nos está enviando",
        "9172": "El valor del campo PUCE Ds_Merchant_MerchantCode no es válido",
        "9173": "Que el comercio revise el campo de la URL OK",
        "9174": "Error Interno",
        "9175": "Error Interno",
        "9181": "Error Interno",
        "9182": "Error Interno",
        "9183": "Error interno",
        "9184": "Error interno",
        "9187": "Error formato (Interno)",
        "9197": "Error al obtener los datos de cesta de la compra",
        "9214": "Su comercio no permite devoluciones por el tipo de firma (Completo)",
        "9216": "El CVV2 tiene más de 3 posiciones",
        "9217": "Error de formato en el CVV2",
        "9218": "El comercio no permite operaciones seguras por las entradas 'operaciones' o 'WebService'",
        "9219": "Se tiene que dirigir a su entidad.",
        "9220": "Se tiene que dirigir a su entidad.",
        "9221": "El cliente no está introduciendo el CVV2",
        "9222": "Existe una anulación asociada a la preautorización",
        "9223": "La preautorización que se desea anular no está autorizada",
        "9224": "Su comercio no permite anulaciones por no tener la firma ampliada",
        "9225": "No existe operación sobre la que realizar la anulación",
        "9226": "Error en los datos de la anulación manual",
        "9227": "Que el comercio revise el campo Ds_Merchant_TransactionDate",
        "9228": "El tipo de tarjeta no puede realizar pago aplazado",
        "9229": "Error con el código de aplazamiento",
        "9230": "Su comercio no permite pago fraccionado (Consulte a su entidad)",
        "9231": "No hay forma de pago aplicable (Consulte con su entidad)",
        "9232": "Forma de pago no disponible",
        "9233": "Forma de pago desconocida",
        "9234": "Nombre del titular de la cuenta no disponible",
        "9235": "Campo Sis_Numero_Entidad no disponible",
        "9236": "El campo Sis_Numero_Entidad no tiene la longitud requerida",
        "9237": "El campo Sis_Numero_Entidad no es numérico",
        "9238": "Campo Sis_Numero_Oficina no disponible",
        "9239": "El campo Sis_Numero_Oficina no tiene la longitud requerida",
        "9240": "El campo Sis_Numero_Oficina no es numérico",
        "9241": "Campo Sis_Numero_DC no disponible",
        "9242": "El campo Sis_Numero_DC no tiene la longitud requerida",
        "9243": "El campo Sis_Numero_DC no es numérico",
        "9244": "Campo Sis_Numero_Cuenta no disponible",
        "9245": "El campo Sis_Numero_Cuenta no tiene la longitud requerida",
        "9246": "El campo Sis_Numero_Cuenta no es numérico",
        "9247": "Dígito de Control de Cuenta Cliente no válido",
        "9248": "El comercio no permite pago por domiciliación",
        "9249": "Error genérico",
        "9250": "Error genérico",
        "9251": "No permite transferencias (Consultar con entidad)",
        "9252": "Por su configuración no puede enviar la tarjeta. (Para modificarlo consulte con la entidad)",
        "9253": "No se ha tecleado correctamente la tarjeta.",
        "9254": "Se tiene que dirigir a su entidad.",
        "9255": "Se tiene que dirigir a su entidad.",
        "9257": "La tarjeta no permite operativa de preautorización",
        "9258": "Tienen que revisar los datos de la validación",
        "9259": "No existe la operación original para notificar o consultar",
        "9260": "Entrada incorrecta al SIS",
        "9261": "Se tiene que dirigir a su entidad.",
        "9280": "Se tiene que dirigir a su entidad.",
        "9281": "Se tiene que dirigir a su entidad.",
        "9282": "Se tiene que dirigir a su entidad.",
        "9284": "No existe operación sobre la que realizar el Pago Adicional",
        "9285": "Tiene más de una operación sobre la que realizar el Pago Adicional",
        "9286": "La operación sobre la que se quiere hacer la operación adicional no está Aceptada",
        "9287": "La operación ha sobrepasado el importe para el Pago Adicional.",
        "9288": "No se puede realizar otro pago Adicional. Se ha superado el número de pagos",
        "9289": "El importe del pago Adicional supera el máximo días permitido.",
        "9290": "Se tiene que dirigir a su entidad.",
        "9291": "Se tiene que dirigir a su entidad.",
        "9292": "Se tiene que dirigir a su entidad.",
        "9293": "Se tiene que dirigir a su entidad.",
        "9295": "Duplicidad de operación. Se puede intentar de nuevo (1 minuto)",
        "9296": "No se encuentra la operación Tarjeta en Archivo inicial",
        "9297": "Número de operaciones sucesivas de Tarjeta en Archivo superado",
        "9298": "No puede realizar este tipo de operativa. (Contacte con su entidad)",
        "9299": "Error en pago con PayPal",
        "9300": "Error en pago con PayPal",
        "9301": "Error en pago con PayPal",
        "9302": "Moneda no válida para pago con PayPal",
        "9304": "No se permite pago fraccionado si la tarjeta no es de FINCONSUM",
        "9305": "Revisar la moneda de la operación",
        "9306": "Valor de Ds_Merchant_PrepaidCard no válido",
        "9307": "Que consulte con su entidad. Operativa de tarjeta regalo no permitida",
        "9308": "Tiempo límite para recarga de tarjeta regalo superado",
        "9309": "Faltan datos adicionales para realizar la recarga de tarjeta prepago",
        "9310": "Valor de Ds_Merchant_Prepaid_Expiry no válido",
        "9311": "Error genérico",
        "9319": "El comercio no pertenece al grupo especificado en Ds_Merchant_Group",
        "9320": "Error generando la referencia",
        "9321": "El identificador no está asociado al comercio",
        "9322": "Que revise el formato del grupo",
        "9323": "Para el tipo de operación F (pago en dos fases) es necesario enviar uno de estos campos. Ds_Merchant_Customer_Mobile o Ds_Merchant_Customer_Mail",
        "9324": "Imposible enviar el link al cliente (Que revise la dirección mail)",
        "9326": "Se han enviado datos de tarjeta en fase primera de un pago con dos fases",
        "9327": "No se ha enviado ni móvil ni email en fase primera de un pago con dos fases",
        "9328": "Token de pago en dos fases inválido",
        "9329": "No se puede recuperar el Token de pago en dos fases.",
        "9330": "Fechas incorrectas de pago dos fases",
        "9331": "La operación no tiene un estado válido o no existe.",
        "9332": "El importe de la operación original y de la devolución debe ser idéntico",
        "9283": "Se tiene que dirigir a su entidad.",
        "9334": "Se tiene que dirigir a su entidad.",
        "9335": "Que revise el valor que envía",
        "9336": "Error genérico",
        "9337": "Error interno (iUPAY)",
        "9338": "No se encuentra la operación iUPAY",
        "9339": "El comercio no dispone de pago iUPAY (Consulte a su entidad)",
        "9340": "Respuesta recibida desde iUPAY no válida",
        "9341": "Error interno (iUPAY)",
        "9344": "El usuario ha elegido aplazar el pago, pero no ha aceptado las condiciones de las cuotas",
        "9345": "Revisar el número de plazos que está enviando.",
        "9346": "Revisar formato en parámetro DS_MERCHANT_PAY_TYPE",
        "9347": "El comercio no está configurado para realizar la consulta de BIN.",
        "9348": "El BIN indicado en la consulta no se reconoce",
        "9349": "Los datos de importe y DCC enviados no coinciden con los registrados en SIS",
        "9350": "No hay datos DCC registrados en SIS para este número de pedido",
        "9351": "Autenticación prepago incorrecta",
        "9352": "El tipo de firma no permite esta operativa",
        "9353": "Clave no válida",
        "9354": "Error descifrando petición al SIS",
        "9355": "El comercio-terminal enviado en los datos cifrados no coincide con el enviado en la petición",
        "9356": "El comercio no tiene activo control de fraude (Consulte con su entidad)",
        "9357": "El comercio tiene activo control de fraude y no existe campo ds_merchant_merchantscf",
        "9358": "No dispone de pago iUPAY",
        "9370": "Error en formato Scf_Merchant_Nif. Longitud máxima 16",
        "9371": "Error en formato Scf_Merchant_Name. Longitud máxima 30",
        "9372": "Error en formato Scf_Merchant_First_Name. Longitud máxima 30",
        "9373": "Error en formato Scf_Merchant_Last_Name. Longitud máxima 30",
        "9374": "Error en formato Scf_Merchant_User. Longitud máxima 45",
        "9375": "Error en formato Scf_Affinity_Card. Valores posibles 'S' o 'N'. Longitud máxima 1",
        "9376": "Error en formato Scf_Payment_Financed. Valores posibles 'S' o 'N'. Longitud máxima 1",
        "9377": "Error en formato Scf_Ticket_Departure_Point. Longitud máxima 30",
        "9378": "Error en formato Scf_Ticket_Destination. Longitud máxima 30",
        "9379": "Error en formato Scf_Ticket_Departure_Date. Debe tener formato yyyyMMddHHmmss.",
        "9380": "Error en formato Scf_Ticket_Num_Passengers. Longitud máxima 1.",
        "9381": "Error en formato Scf_Passenger_Dni. Longitud máxima 16.",
        "9382": "Error en formato Scf_Passenger_Name. Longitud máxima 30.",
        "9383": "Error en formato Scf_Passenger_First_Name. Longitud máxima 30.",
        "9384": "Error en formato Scf_Passenger_Last_Name. Longitud máxima 30.",
        "9385": "Error en formato Scf_Passenger_Check_Luggage. Valores posibles 'S' o 'N'. Longitud máxima 1.",
        "9386": "Error en formato Scf_Passenger_Special_luggage. Valores posibles 'S' o 'N'. Longitud máxima 1.",
        "9387": "Error en formato Scf_Passenger_Insurance_Trip. Valores posibles 'S' o 'N'. Longitud máxima 1.",
        "9388": "Error en formato Scf_Passenger_Type_Trip. Valores posibles 'N' o 'I'. Longitud máxima 1.",
        "9389": "Error en formato Scf_Passenger_Pet. Valores posibles 'S' o 'N'. Longitud máxima 1.",
        "9390": "Error en formato Scf_Order_Channel. Valores posibles 'M' (móvil), 'P' (PC) o 'T' (Tablet)",
        "9391": "Error en formato Scf_Order_Total_Products. Debe tener formato numérico y longitud máxima de 3.",
        "9392": "Error en formato Scf_Order_Different_Products. Debe tener formato numérico y longitud máxima de 3.",
        "9393": "Error en formato Scf_Order_Amount. Debe tener formato numérico y longitud máxima de 19.",
        "9394": "Error en formato Scf_Order_Max_Amount. Debe tener formato numérico y longitud máxima de 19.",
        "9395": "Error en formato Scf_Order_Coupon. Valores posibles 'S' o 'N'",
        "9396": "Error en formato Scf_Order_Show_Type. Debe longitud máxima de 30.",
        "9397": "Error en formato Scf_Wallet_Identifier",
        "9398": "Error en formato Scf_Wallet_Client_Identifier",
        "9399": "Error en formato Scf_Merchant_Ip_Address",
        "9400": "Error en formato Scf_Merchant_Proxy",
        "9401": "Error en formato Ds_Merchant_Mail_Phone_Number. Debe ser numérico y de longitud máxima 19",
        "9402": "Error en llamada a SafetyPay para solicitar token url",
        "9403": "Error en proceso de solicitud de token url a SafetyPay",
        "9404": "Error en una petición a SafetyPay",
        "9405": "Solicitud de token url denegada SAFETYPAY",
        "9406": "Se tiene que poner en contacto con su entidad para que revisen la configuración del sector de actividad de su comercio",
        "9407": "El importe de la operación supera el máximo permitido para realizar un pago de premio de apuesta (Gambling)",
        "9408": "La tarjeta debe de haber operado durante el último año para poder realizar un pago de premio de apuesta (Gambling)",
        "9409": "La tarjeta debe ser una Visa o MasterCard nacional para realizar un pago de premio de apuesta (Gambling)",
        "9410": "Denegada por el emisor",
        "9411": "Error en la configuración del comercio (Remitir a su entidad)",
        "9412": "La firma no es correcta",
        "9413": "Denegada, consulte con su entidad.",
        "9415": "El tipo de producto no es correcto",
        "9428": "Operación débito no segura",
        "9429": "Error en la versión enviada por el comercio (Ds_SignatureVersion)",
        "9430": "Error al decodificar el parámetro Ds_MerchantParameters",
        "9431": "Error del objeto JSON que se envía codificado en el parámetro Ds_MerchantParameters",
        "9432": "Error FUC del comercio erróneo",
        "9433": "Error Terminal del comercio erróneo",
        "9434": "Error ausencia de número de pedido en la op. del comercio",
        "9435": "Error en el cálculo de la firma",
        "9436": "Error en la construcción del elemento padre REQUEST",
        "9437": "Error en la construcción del elemento DS_SIGNATUREVERSION",
        "9438": "Error en la construcción del elemento DATOSENTRADA",
        "9439": "Error en la construcción del elemento DS_SIGNATURE",
        "9440": "Error genérico",
        "9441": "Error no tenemos bancos para Mybank",
        "9442": "Error genérico",
        "9443": "No se permite pago con esta tarjeta",
        "9444": "Se está intentando acceder usando firmas antiguas y el comercio está configurado como HMAC SHA256",
        "9445": "Error genérico",
        "9446": "Es obligatorio indicar la forma de pago",
        "9448": "El comercio no tiene el método de pago 'Pago DINERS'",
        "9449": "Tipo de pago de la operación no permitido para este tipo de tarjeta",
        "9450": "Tipo de pago de la operación no permitido para este tipo de tarjeta",
        "9451": "Tipo de pago de la operación no permitido para este tipo de tarjeta",
        "9453": "No se permiten pagos con ese tipo de tarjeta",
        "9454": "No se permiten pagos con ese tipo de tarjeta",
        "9455": "No se permiten pagos con ese tipo de tarjeta",
        "9456": "No tiene método de pago configurado (Consulte a su entidad)",
        "9459": "No tiene método de pago configurado (Consulte a su entidad)",
        "9460": "No tiene método de pago configurado (Consulte a su entidad)",
        "9461": "No tiene método de pago configurado (Consulte a su entidad)",
        "9462": "Método de pago no disponible para conexión HOST to HOST",
        "9463": "Método de pago no permitido",
        "9465": "No tiene método de pago configurado (Consulte a su entidad)",
        "9466": "La referencia que se está utilizando no existe.",
        "9467": "La referencia que se está utilizando está dada de baja",
        "9468": "Se está utilizando una referencia que se generó con un adquirente distinto al adquirente que la utiliza.",
        "9469": "Error, no se ha superado el proceso de fraude MR",
        "9470": "Error la solicitud del primer factor ha fallado.",
        "9471": "Error en la URL de redirección de solicitud del primer factor.",
        "9472": "Error al montar la petición de Autenticación de PPII.",
        "9473": "Error la respuesta de la petición de Autenticación de PPII es nula.",
        "9474": "Error el statusCode de la respuesta de la petición de Autenticación de PPII es nulo",
        "9475": "Error el idOperación de la respuesta de la petición de Autenticación de PPII es nulo",
        "9476": "Error tratando la respuesta de la Autenticación de PPII",
        "9477": "Error se ha superado el tiempo definido entre el paso 1 y 2 de PPI",
        "9478": "Error tratando la respuesta de la Autorización de PPII",
        "9479": "Error la respuesta de la petición de Autorización de PPII es nula",
        "9480": "Error el statusCode de la respuesta de la petición de Autorización de PPII es nulo.",
        "9481": "Error, el comercio no es Payment Facilitator",
        "9482": "Error el idOperación de la respuesta de una Autorización OK es nulo o no coincide con el idOp. de la Auth.",
        "9483": "Error la respuesta de la petición de devolución de PPII es nula.",
        "9484": "Error el statusCode o el idPetición de la respuesta de la petición de Devolución de PPII es nulo.",
        "9485": "Error producido por la denegación de la devolución.",
        "9486": "Error la respuesta de la petición de consulta de PPII es nula.",
        "9487": "El comercio terminal no tiene habilitado el método de pago Paygold.",
        "9488": "El comercio no tiene el método de pago 'Pago MOTO/Manual' y la operación viene marcada como pago MOTO.",
        "9489": "Error de datos. Operación MPI Externo no permitida",
        "9490": "Error de datos. Se reciben parámetros MPI Redsys en operación MPI Externo",
        "9491": "Error de datos. SecLevel no permitido en operación MPI Externo",
        "9492": "Error de datos. Se reciben parámetros MPI Externo en operación MPI Redsys",
        "9493": "Error de datos. Se reciben parámetros de MPI en operación no segura",
        "9494": "FIRMA OBSOLETA",
        "9495": "Error en datos enviados ApplePay o AndroidPay",
        "9496": "El comercio no tiene dado de alta el método de pago AndroidPay",
        "9497": "El comercio no tiene dado de alta el método de pago ApplePay",
        "9498": "La moneda y/o importe informados en La operación de ApplePay no coinciden",
        "9499": "Error obteniendo claves del comercio en Android/Apple Pay",
        "9500": "Error al recuperar tarjetas DCC Dinámico",
        "9501": "Error en la validación de datos enviados para genera el Id operación",
        "9502": "No se han obtenido datos asociados al Id Operación enviado por el comercio",
        "9503": "Error en la validación del número de pedido",
        "9504": "Error en la validación del tipo de transacción",
        "9505": "Error en la validación de la moneda",
        "9506": "Error en la validación del importe",
        "9507": "El Id Operación enviado por el comercio no tiene vigencia",
        "9511": "Excepción al tratar el mensaje",
        "9512": "Error en la respuesta de consulta de BINES",
        "9513": "Tipo de tarjeta no informado",
        "9514": "Marca de la tarjeta desconocida",
        "9515": "El comercio no tiene activado pago Amex",
        "9516": "Error al montar el mensaje ACPReq",
        "9517": "Error al establecer la clave",
        "9518": "Error al grabar los datos",
        "9519": "Error al parsear la respuesta del xml",
        "9520": "El mensaje SecurePlus de sesión está vacío",
        "9521": "El xml de respuesta viene vacío",
        "9522": "No se han recibido parámetros en datosentrada",
        "9523": "La firma calculada no coincide con la recibida en la respuesta",
        "9524": "Error en la autenticación",
        "9525": "Tarjeta privada no válida en este comercio",
        "101": "Tarjeta caducada",
        "129": "Código de seguridad CVV incorrecto.",
        "180": "Denegación emisor",
        "0184": "El usuario no ha podido validar correctamente la identidad del propietario de la tarjeta.",
        "184": "El cliente de la operación no se ha autenticado",
        "190": "Denegación emisor",
        "904": "Problema con la configuración de su comercio. Dirigirse a la entidad.",
        "915": "El titular ha cancelado la operación de pago.",
        "9104": "Comercio con “titular seguro” y titular sin clave de compra segura",
        "9256": "El comercio no permite operativa de preautorización",
        "9700": "PayPal ha devuelto un KO",
        "9801": "Denegada por iUPAY",
        "9899": "No están correctamente firmados los datos que nos envían en el Ds_Merchant_Data.",
        "9900": "SafetyPay ha devuelto un KO",
        "9909": "Error interno",
        "9912": "Emisor no disponible",
        "9913": "Excepción en el envío SOAP de la notificación",
        "9914": "Respuesta KO en el envío SOAP de la notificación",
        "9915": "Cancelado por el titular",
        "9928": "El titular ha cancelado la preautorización",
        "9929": "El titular ha cancelado la operación",
        "9930": "La transferencia está pendiente",
        "9931": "Consulte con su entidad",
        "9932": "Denegada por Fraude (LINX)",
        "9933": "Denegada por Fraude (LINX)",
        "9934": "Denegada (Consulte con su entidad)",
        "9935": "Denegada (Consulte con su entidad)",
        "9992": "Solicitud de PAE",
        "9994": "No ha seleccionado ninguna tarjeta de la cartera.",
        "9995": "Recarga de prepago denegada",
        "9996": "No permite la recarga de tarjeta prepago",
        "9997": "Con una misma tarjeta hay varios pagos en 'vuelo' en el momento que se finaliza uno el resto se deniegan con este código. Esta restricción se realiza por seguridad.",
        "9998": "Operación en proceso de solicitud de datos de tarjeta",
        "9999": "Operación que ha sido redirigida al emisor a autenticar"
    };

    function init() {

        console.log('\r\n\u2591\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2557\u2591\u2588\u2588\u2557\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2588\u2588\u2557\u2003\u2003\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u2591\u2588\u2588\u2557\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2588\u2588\u2557\r\n\u2588\u2588\u2554\u2550\u2550\u2550\u2550\u255D\u2588\u2588\u2551\u2591\u2588\u2588\u2551\u2591\u2591\u2588\u2588\u2557\u2591\u2591\u2588\u2588\u2551\u2003\u2003\u2588\u2588\u2554\u2550\u2550\u2550\u2550\u255D\u2591\u2588\u2588\u2551\u2591\u2591\u2588\u2588\u2557\u2591\u2591\u2588\u2588\u2551\r\n\u255A\u2588\u2588\u2588\u2588\u2588\u2557\u2591\u2588\u2588\u2551\u2591\u255A\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2554\u255D\u2003\u2003\u2588\u2588\u2588\u2588\u2588\u2557\u2591\u2591\u2591\u255A\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2554\u255D\r\n\u2591\u255A\u2550\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2551\u2591\u2591\u2588\u2588\u2588\u2588\u2554\u2550\u2588\u2588\u2588\u2588\u2551\u2591\u2003\u2003\u2588\u2588\u2554\u2550\u2550\u255D\u2591\u2591\u2591\u2591\u2588\u2588\u2588\u2588\u2554\u2550\u2588\u2588\u2588\u2588\u2551\u2591\r\n\u2588\u2588\u2588\u2588\u2588\u2588\u2554\u255D\u2588\u2588\u2551\u2591\u2591\u255A\u2588\u2588\u2554\u255D\u2591\u255A\u2588\u2588\u2554\u255D\u2591\u2003\u2003\u2588\u2588\u2551\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u255A\u2588\u2588\u2554\u255D\u2591\u255A\u2588\u2588\u2554\u255D\u2591\r\n\u255A\u2550\u2550\u2550\u2550\u2550\u255D\u2591\u255A\u2550\u255D\u2591\u2591\u2591\u255A\u2550\u255D\u2591\u2591\u2591\u255A\u2550\u255D\u2591\u2591\u2003\u2003\u255A\u2550\u255D\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u2591\u255A\u2550\u255D\u2591\u2591\u2591\u255A\u2550\u255D\u2591\u2591');

        InitFunctionsController();
        GlobalFunctionsController();
        BrowserFunctionsController();
        PluginsInitController();
        EventosController();

        window.siw_consola('SIW JS', 'Loaded');

    }

    /** ************************************************************************************
     *
     * BROWSER AND HACKS
     */
    function BrowserFunctionsController() {

        let matched, browser;

        window.currenturl = document.location.href;
        const curl = new URL(window.currenturl);
        window.currentonlyurl = curl.origin;

        $.uaMatch = function (ua) {
            ua = ua.toLowerCase();

            let match = /(chrome)[ \/]([\w.]+)/.exec(ua) ||
                /(webkit)[ \/]([\w.]+)/.exec(ua) ||
                /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
                /(msie) ([\w.]+)/.exec(ua) ||
                ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) ||
                [];

            return {
                browser: match[1] || "",
                version: match[2] || "0"
            };
        };

        matched = jQuery.uaMatch(navigator.userAgent);
        browser = {};

        if (matched.browser) {
            browser[matched.browser] = true;
            browser.version = matched.version;
        }

        if (browser.chrome) {
            browser.webkit = true;
        } else if (browser.webkit) {
            browser.safari = true;
        }

        $.browser = browser;

        if ($.browser.mozilla) {
            $('body').addClass('firefox');
        }

    }


    /** ************************************************************************************
     *
     * EVENTOS
     */

    function EventosController() {

            $(document).ready(function() {

                //COPY FEATURE
                $(document).on('dblclick', '.copy-feature', function () {
                    var $temp = $("<input>");
                    $("body").append($temp);
                    $temp.val($(this).text()).select();
                    try {
                        document.execCommand("copy");
                        alert("Texto copiado: " + $temp.val());
                    } catch (err) {
                        console.error("Error al copiar texto: ", err);
                        alert("Error al copiar texto");
                    }
                    $temp.remove();
                });

                //COPY FEATURE ICON

                $(document).on('click', '.copy-feature-with-target', function () {

                    var target = $(this).attr('data-copytarget');

                    var $temp = $("<input>");
                    $("body").append($temp);
                    $temp.val($('.copy-feature-target-' + target).text()).select();
                    try {
                        document.execCommand("copy");
                        alert("Texto copiado: " + $temp.val());
                    } catch (err) {
                        console.error("Error al copiar texto: ", err);
                        alert("Error al copiar texto");
                    }
                    $temp.remove();
                });


                $(document).on('click', '#syncBtn', function (e) {
                    e.preventDefault();

                    window.bbb.syncBtn('sync');

                    $.ajaxSetup({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                    });

                    $.post('/app/calendarios/ajax/GSincronizacion', {

                    }).done(function (response) {
                        window.bbb.syncBtn('ok');
                    }).fail(function (xhr, status, error) {
                        window.bbb.syncBtn('ko');
                        if (xhr.status === '419') {
                            window.location.replace("/login");
                        }
                    }).always(function () {
                        window.bbb.syncBtn('idle');
                    });
                });


        });

    }


    /** ************************************************************************************
     *
     * GLOBALS FUNCTIONS
     */
    function GlobalFunctionsController() {

        window.siw_labmouse = function () {
            console.log('I\'M Alive!')
        };

        window.siw_slugify = function (str) {
            str = str.replace(/^\s+|\s+$/g, ''); // trim
            str = str.toLowerCase();
            var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
            var to = "aaaaeeeeiiiioooouuuunc------";
            for (var i = 0, l = from.length; i < l; i++) {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }

            str = str.replace(/[^a-z0-9 -]/g, '')
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-');
            return str;
        };

        window.siw_checkFields = function (form) {
            let existeInvalidos = [];
            $(form + " input.required").each(function (i) {
                if ($(this).hasClass('is-valid')) {
                    existeInvalidos.push(true)
                } else {
                    existeInvalidos.push(false)
                }
            });
            let existeInvalidosChecked = existeInvalidos.every(element => element === true)
            if (existeInvalidosChecked) {
                $(form + " button[type=submit]").prop('disabled', false);
            } else {
                $(form + " button[type=submit]").prop('disabled', true);
            }
        };

        window.siw_log = function (mensaje, type) {

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            let m = new Date();
            let ahora = m.getUTCFullYear() + "-" + (m.getUTCMonth() + 1) + "-" + m.getUTCDate();
            $.post('/ajax/logs', {mensaje: mensaje, type: type})
                .fail(function (xhr, status, error) {
                    if (xhr.status == '419') {
                        window.location.replace("/login");
                    }
                });

        };

        window.siw_consola = function (label, data) {
            var titulo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'CONSOLA SIW';
            var estiloMensaje = 'background: black; color: orange; padding: 2px 5px; font-weight: bold;';
            var mensajePersonalizado = titulo;
            var error = new Error();
            var stackLine = error.stack.split("\n")[2].trim();
            console.log("%c".concat(mensajePersonalizado), estiloMensaje, label, data, '\nLlamado desde:', stackLine);
        };

        window.consola = function (label, data, tipo = 'info') {
            var titulo = 'CONSOLA SIW';
            var error = new Error();
            var stackLine = error.stack.split("\n")[2].trim();

            // Estilos por tipo
            var estilos = {
                error: 'background: #dc3545; color: white; padding: 2px 5px; font-weight: bold;',
                warn: 'background: #ffc107; color: black; padding: 2px 5px; font-weight: bold;',
                info: 'background: #17a2b8; color: white; padding: 2px 5px; font-weight: bold;',
                debug: 'background: #6f42c1; color: white; padding: 2px 5px; font-weight: bold;',
                log: 'background: #28a745; color: white; padding: 2px 5px; font-weight: bold;'
            };

            var estilo = estilos[tipo] || estilos.info;

            switch(tipo) {
                case 'error':
                    console.error("%c".concat(titulo +  '   ERROR'), estilo, label, data, '\nLlamado desde:', stackLine);
                    break;
                case 'warn':
                    console.warn("%c".concat(titulo +   ' WARNING'), estilo, label, data, '\nLlamado desde:', stackLine);
                    break;
                case 'debug':
                    console.debug("%c".concat(titulo +  '   DEBUG'), estilo, label, data, '\nLlamado desde:', stackLine);
                    break;
                case 'log':
                    console.log("%c".concat(titulo +    '     LOG'), estilo, label, data, '\nLlamado desde:', stackLine);
                    break;
                default: // info
                    console.info("%c".concat(titulo +   '    INFO'), estilo, label, data, '\nLlamado desde:', stackLine);
            }
        };

        window.siw_dumpls = function dumpLocalStorage(titulo = '📦 LOCAL STORAGE DUMP', clear = false) {

            if(clear) {
                console.clear();
            }

            if (localStorage.length === 0) {
                console.warn('%c[LOCAL STORAGE VACÍO]', 'color: gray; font-style: italic;');
                return;
            }

            const estiloTitulo = 'background: #333; color: #00ff99; padding: 4px 8px; font-weight: bold; font-size: 14px;';
            const estiloClave = 'color: #66d9ef; font-weight: bold;';
            const estiloValor = 'color: #f8f8f2;';
            const estiloSeparador = 'color: #444;';

            console.log(`%c${titulo}`, estiloTitulo);

            for (let i = 0; i < localStorage.length; i++) {
                const clave = localStorage.key(i);
                let valor = localStorage.getItem(clave);

                try {
                    valor = JSON.parse(valor);
                } catch (e) {
                    // no es JSON, lo dejamos tal cual
                }

                console.log(`%c${clave}%c: %c${JSON.stringify(valor, null, 2)}`,
                    estiloClave, estiloSeparador, estiloValor);
            }

            console.log('%c-- Fin del dump --', 'color: gray; font-style: italic;');
        };

        window.siw_dconsola = function (label, data) {
            var titulo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'CONSOLA SIW';
            var debugValue = localStorage.getItem('debug');
            if (debugValue) {
                var estiloMensaje = 'background: black; color: orange; padding: 2px 5px; font-weight: bold;';
                var mensajePersonalizado = titulo;

                // Captura el stack trace
                var error = new Error();
                var stackLine = error.stack.split("\n")[2].trim(); // La tercera línea suele ser la llamada relevante

                // Imprime el mensaje con información de la línea
                console.log("%c".concat(mensajePersonalizado), estiloMensaje, label, data, '\nLlamado desde:', stackLine);
            }
        };

        window.controlCheck = function (switch_elem, on) {
            if (on) {
                if ($(switch_elem)[0].checked) {
                } else {
                    $(switch_elem).trigger('click').attr("checked", "checked");
                }
            } else {
                if ($(switch_elem)[0].checked) {
                    $(switch_elem).trigger('click').removeAttr("checked");
                }
            }
        };

        window.populateForm = function (el, jsonData, fieldsJson) {

            var form = $(el);
            var dataRaw = JSON.parse(jsonData);
            var data = dataRaw.data;
            var fields = JSON.parse(fieldsJson);

            for (var i = 0; i < fields.length; i++) {

                var field = fields[i];
                var idname = field.db.field.replace(/_/g, '');
                var input = form.find('[data-dbfield="' + field.db.field + '"]');

                if (input.length > 0) {

                    if (field.form.type === 'checkbox') {

                        var inputId = '#' + input.attr('id');
                        if (data[field.db.field] === 'on') {
                            window.controlCheck(inputId, true);
                        } else {
                            window.controlCheck(inputId, false);
                        }

                    } else if (field.form.type === 'textarea' && input.hasClass('html-editor')) {

                        input.summernote('code', data[field.db.field]);

                    } else if (field.form.type === 'select' && input.hasClass('select2')) {

                        input.select2().val(data[field.db.field]).trigger('change');

                    } else if (field.form.type === 'select') {

                        input.val(data[field.db.field]);

                    } else {

                        input.val(data[field.db.field]);

                    }

                }
            }
        };

        window.populateTableShow = function (modalId, jsonData, fieldsJson) {

            var modal = $(modalId);
            var table = modal.find('table tbody');

            var dataRaw = JSON.parse(jsonData);
            var data = dataRaw.data;

            var value;

            var fieldsArray = JSON.parse(fieldsJson);

            table.empty();
            fieldsArray.forEach(function (field) {
                if (field.visibility.showOnPopup) {
                    var fieldName = field.db.field;
                    var idName = fieldName.replace(/_/g, '');
                    var row = $('<tr>');
                    row.append('<th class="' + field.popup.classTitle + '">' + field.table.titulo + '</th>');

                    var dateValue = data[fieldName];

                    if (_isValidISOFormat(dateValue)) {
                        value = _formatISODateToDMYHM(dateValue);
                    } else {
                        value = (data[fieldName] === null) ? '' : data[fieldName];
                    }

                    if (field.form.type === 'textarea' && field.form.class === 'html-editor') {
                        row.append('<td colspan="2" class="' + field.popup.classData + '">' + value + '</td>');
                    } else {
                        row.append('<td class="' + field.popup.classData + '">' + value + '</td>');
                    }
                    table.append(row);
                }
            });
        };

        function _formatISODateToDMYHM(dateString) {
            var date = new Date(dateString);
            var day = date.getDate();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var seconds = date.getSeconds();

            return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        };

        function _isValidISOFormat(dateString) {
            var isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6}Z$/;
            return isoRegex.test(dateString);
        };

        window.clearForm = function (formId, memoriaCreate, memoriaUpdate) {

            let clearnow;

            if (memoriaCreate && memoriaUpdate) {
                clearnow = false;
            }
            if (!memoriaCreate && memoriaUpdate) {
                clearnow = true;
            }
            if (memoriaCreate && !memoriaUpdate) {
                clearnow = false;
            }
            if (!memoriaCreate && !memoriaUpdate) {
                clearnow = true;
            }

            if (clearnow) {
                var form = $(formId);
                form.find('input, select, textarea').not(':input[type=submit], :input[name="_token"]').each(function () {
                    var element = $(this);

                    var id = element.attr('id');
                    var nombre = element.attr('name');
                    var tipo = element.attr('type');
                    var clase = (element.attr('class')) ?? '';

                    console.log(nombre, 'id: ' + id + ' | tipo: ' + tipo + ' | clase: ' + clase);

                    // Switchery
                    if (element.attr('type') === 'checkbox') {
                        window.controlCheck('#' + element.attr('id'), false);
                    }
                    // Select2
                    else if (clase.indexOf('select2') !== -1) {
                        $('#' + element.attr('id')).val(0).select2().change();
                    }
                    // Texto HTML
                    else if (clase.indexOf('html-editor') !== -1) {
                        $('#' + element.attr('id')).summernote('reset');
                    }
                    // Others
                    else {
                        $('#' + element.attr('id')).val('');
                    }

                });

                $(formId + ' .validacion').remove();

                window._estados_memoria_create = false;
                window._estados_memoria_update = false;

            }

        };

        window.bbb.getData = function (route, id) {

            let respuesta;

            let $that = $(this);

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            $.ajax({
                type: 'POST',
                cache: true,
                context: this,
                dataType: 'text',
                async: false,
                contentType: "application/x-www-form-urlencoded; charset=iso-8859-1",
                url: route,
                data: {
                    'id': id
                },
                beforeSend: function () {
                },
                success: function (response) {
                    respuesta = response;
                },
                error: function (err) {
                    window.siw_consola('err', err);
                    window.siw_consola('err.responseText', err.responseText);

                    if (err.status == '419') {
                        window.location.replace("/logout");
                    }
                },
                complete: function () {
                }
            });

            return respuesta;

        };

        window.bbb.delData = function (route, id) {

            let respuesta;

            let $that = $(this);

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            $.ajax({
                type: 'POST',
                cache: true,
                context: this,
                dataType: 'text',
                async: false,
                contentType: "application/x-www-form-urlencoded; charset=iso-8859-1",
                url: route,
                data: {
                    'id': id
                },
                beforeSend: function () {
                },
                success: function (response) {
                    respuesta = response;
                },
                error: function (err) {
                    window.siw_consola('err', err);
                    window.siw_consola('err.responseText', err.responseText);

                    if (err.status == '419') {
                        window.location.replace("/logout");
                    }
                },
                complete: function () {
                }
            });

            return respuesta;

        },

        window.bbb.setData = function (route, formId) {

            let respuesta;

            let $that = $(this);

            var formulario = $('#' + formId);
            var formData = formulario.serialize();

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            $.ajax({
                type: 'POST',
                cache: true,
                context: this,
                dataType: 'text',
                async: false,
                contentType: "application/x-www-form-urlencoded; charset=iso-8859-1",
                url: route,
                data: formData,
                beforeSend: function () {
                },
                success: function (response) {
                    respuesta = response
                },
                error: function (err) {
                    window.siw_consola('err', err);
                    window.siw_consola('err.responseText', err.responseText);

                    if (err.status == '419') {
                        window.location.replace("/logout");
                    }
                },
                complete: function () {
                }
            });

            return respuesta;

        },

        window.bbb.includeMensaje = function (msg, tipo) {

            let html = '';
            html += '<div class="alert alert-' + tipo + ' alert-dismissible fade show" role="alert">';
            html += msg;
            html += '    <button type="button" class="close" data-dismiss="alert" aria-label="Close" style="margin: 12px;"><i class="ik ik-x"></i></button>';
            html += '</div>';

            $('#include-mensaje').html(html);

        },

        window.bbb.toMoney = function (x) {
            var decimalSeparator = ',';
            x = x.replace(/\./g, decimalSeparator);
            var thousandSeparator = '.';
            x = x.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
            return x;
        };

        window.bbb.formatPrice = function (price) {
            price = parseFloat(price);
            if (price > 0) {
                return window.bbb.toMoney(parseFloat(price).toFixed(2)) + " €";
            } else {
                return '-';
            }
        };

        window.bbb.getCustomData = function (method, route, params, loader = false) {

            let respuesta;

            let $that = $(this);

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            $.ajax({
                type: method,
                cache: true,
                context: this,
                dataType: 'text',
                async: false,
                contentType: "application/x-www-form-urlencoded; charset=iso-8859-1",
                url: route,
                data: params,
                beforeSend: function () {
                    if (loader) loader.show();
                },
                success: function (response) {
                    respuesta = response;
                },
                error: function (err) {
                    window.siw_consola('err', err);
                    window.siw_consola('err.responseText', err.responseText);
                    if (err.status == '419') {
                        window.location.replace("/logout");
                    }
                },
                complete: function () {
                    if (loader) loader.hide();
                }
            });

            return respuesta;

        };

        window.bbb.getCustomDataWithPromise = function (method, route, params, loader = false) {
            return new Promise((resolve, reject) => {
                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                });

                $.ajax({
                    type: method,
                    cache: true,
                    context: this,
                    dataType: 'json',
                    async: true,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    url: route,
                    data: params,
                    beforeSend: function () {
                        if (loader) loader.show();
                    },
                    success: function (response) {
                        resolve(response);
                    },
                    error: function (xhr, status, error) {
                        reject(xhr.responseJSON || xhr.statusText);
                        if (xhr.status === 419) {
                            window.location.replace("/logout");
                        }
                    },
                    complete: function () {
                        if (loader) loader.hide();
                    }
                });
            });
        };

        window.bbb.alert = function(type, message, title) {

            const defaultTitles = {
                'success': 'Operación Exitosa',
                'error': 'Error',
                'info': 'Información',
                'warning': 'Alerta'
            };

            // Si no se proporciona un título, usar el título por defecto basado en el tipo
            if (!title) {
                title = defaultTitles[type] || 'Notificación';
            }

            // Si no se proporciona un mensaje, establecer uno genérico
            if (!message) {
                message = 'No se proporcionó un mensaje detallado.';
            }

            // Si no se proporciona un tipo, usar 'info' como tipo por defecto
            if (!type) {
                type = 'info';
            }

            swal({
                icon: type,
                title: title,
                text: message
            });
        };

        window.bbb.notify = function(type, message, title) {
            'use strict';
            $('.jq-toast-wrap').removeClass('bottom-left bottom-right top-left top-right mid-center');
            $(".jq-toast-wrap").css({
                "top": "",
                "left": "",
                "bottom": "",
                "right": ""
            });
            $.toast({
                heading: title,
                text: message,
                position: String('bottom-right'),
                icon: type,
                stack: false,
                loaderBg: '#f96868'
            })
        };

        window.bbb.syncBtn = function(status) {

            var $syncBtn = $('#syncBtn');
            if (status === 'sync') {
                $syncBtn.html('<i class="fa fa-spinner fa-spin" style="font-size: 19px;"></i>');
            }
            else if(status === 'ok') {
                $syncBtn.html('<i class="ik ik-check"></i>');
            }
            else if(status === 'ko') {
                $syncBtn.html('<i class="ik ik-alert-triangle"></i>');
            }
            else  {
                $syncBtn.html('<i class="ik ik-refresh-ccw"></i>');
            }

        },

        window.bbb.RSCode = function(key) {

            if (key === null) {
                return '<span class="badge-block badge badge-secondary">Waiting...</span>';
            }

            const message = rscodes[key];
            const displayMessage = message
                ? (message.length > 30 ? message.substring(0, 30) + "..." : message)
                : "Código no encontrado";

            const badgeClass = key === '0000' ? 'badge-success' : 'badge-dark';

            return `<span title="(${key}) ${message || 'Código no encontrado'}" class="badge-block badge ${badgeClass}">
                ${displayMessage}
            </span>`;
        };

        window.siw_log = (function () {
            const estilos = {
                base: 'padding: 2px 6px; font-weight: bold; font-family: monospace;',
                log: 'background: #1e1e1e; color: #9cdcfe;',
                info: 'background: #007acc; color: #fff;',
                warn: 'background: #ff8800; color: #000;',
                error: 'background: #ff0033; color: #fff;',
                notify: 'background: #00cc66; color: #fff;',
            };

            const niveles = ['log', 'info', 'warn', 'error', 'notify'];

            function getSettings() {
                return {
                    enabled: localStorage.getItem('siw.debug') === 'true',
                    level: localStorage.getItem('siw.debug.level') || 'log',
                    env: localStorage.getItem('siw.debug.env') || 'local',
                    currentEnv: window.location.hostname.includes('localhost') || window.location.hostname === '127.0.0.1' ? 'local' : 'production',
                };
            }

            function getCallerLocation() {
                const stack = new Error().stack.split('\n');
                return stack[3]?.trim() || 'origen desconocido';
            }

            function shouldLog(type, settings) {
                const minIndex = niveles.indexOf(settings.level);
                const currentIndex = niveles.indexOf(type);
                return currentIndex >= minIndex;
            }

            function log(tipo, mensaje, data = null, titulo = 'SIW LOG') {
                const settings = getSettings();

                if (!settings.enabled) return;
                if (settings.env !== settings.currentEnv) return;
                if (!shouldLog(tipo, settings)) return;

                const estilo = estilos.base + (estilos[tipo] || estilos.log);
                const timestamp = new Date().toISOString();
                const caller = getCallerLocation();

                console.log(`%c[${titulo}] ${timestamp}`, estilo, mensaje, data ?? '', '\n➡️ Desde:', caller);
            }

            const wrapper = function (mensaje, data, titulo) {
                log('log', mensaje, data, titulo);
            };

            niveles.forEach((nivel) => {
                wrapper[nivel] = function (mensaje, data, titulo) {
                    log(nivel, mensaje, data, titulo);
                };
            });

            wrapper.config = {
                enable: () => localStorage.setItem('siw.debug', 'true'),
                disable: () => localStorage.setItem('siw.debug', 'false'),
                setLevel: (nivel) => {
                    if (niveles.includes(nivel)) localStorage.setItem('siw.debug.level', nivel);
                },
                setEnv: (env) => {
                    if (['local', 'production'].includes(env)) localStorage.setItem('siw.debug.env', env);
                },
                current: () => getSettings(),
            };

            return wrapper;
        })();

        window.bbb.checkPermissions = async function(permissionsArray) {
            try {
                const response = await fetch('/check-permissions', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    },
                    body: JSON.stringify({ permissions: permissionsArray })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                return await response.json();

            } catch (error) {
                console.error('Error checking permissions:', error);
                return {};
            }
        };

        window.bbb.hasPermission = async function(permission) {
            const results = await checkPermissions([permission]);
            return results[permission] || false;
        };

        window.bbb.toggleElementsByPermission = async function(permissionElementMap) {
            const permissions = Object.keys(permissionElementMap);
            const results = await checkPermissions(permissions);

            for (const [permission, selector] of Object.entries(permissionElementMap)) {
                const elements = document.querySelectorAll(selector);
                elements.forEach(element => {
                    element.style.display = results[permission] ? 'block' : 'none';
                });
            }
        };

        window.bbb.confirm = function(options, onConfirm, onCancel) {
            const defaults = {
                icon:              'warning',
                title:             '¿Estás seguro?',
                text:              '',
                confirmButtonText: 'Sí, continuar',
                cancelButtonText:  'Cancelar',
            };

            const config = Object.assign({}, defaults, options);

            swal({
                title: config.title,
                text: config.text,
                icon: 'warning',
                buttons: [config.cancelButtonText, config.confirmButtonText],
            }).then(function(confirmed) {
                if (confirmed && typeof onConfirm === 'function') {
                    onConfirm();
                } else if (!confirmed && typeof onCancel === 'function') {
                    onCancel();
                }
            });
        };

    }

    /** ************************************************************************************
     *
     * PLUGINS CONTROLLERS
     */
    function PluginsInitController() {

        try{

            /**
             * SELECT2
             */

            $('.select2').select2({
                width: 'resolve',
                placeholder: "-- Please Select --"
            });

            /**
             * Image Drag and Drop
             */

            $('.input-images-siw').imageUploader({
                'accept': 'image/*',
                'maxFiles': 1
            });

            /**
             * DATATABLES
             */
            $.extend(jQuery.fn.dataTableExt.oSort, {
                "date-uk-pre": function (a) {
                    let ukDatea = a.split('/');
                    return (ukDatea[2] + ukDatea[1] + ukDatea[0]) * 1;
                },

                "date-uk-asc": function (a, b) {
                    return ((a < b) ? -1 : ((a > b) ? 1 : 0));
                },

                "date-uk-desc": function (a, b) {
                    return ((a < b) ? 1 : ((a > b) ? -1 : 0));
                }
            });

            $('.datatable').DataTable({
                "order": [[ 0, "asc" ]],
                "pageLength": 25,
                "language": {
                    "sProcessing":     "Procesando...",
                    "sLengthMenu":     "Mostrar _MENU_ registros",
                    "sZeroRecords":    "No se encontraron resultados",
                    "sEmptyTable":     "Ningún dato disponible en esta tabla",
                    "sInfo":           "Registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty":      "Registros del 0 al 0 de un total de 0 registros",
                    "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
                    "sInfoPostFix":    "",
                    "sSearch":         "Buscar:",
                    "sUrl":            "",
                    "sInfoThousands":  ",",
                    "sLoadingRecords": "Cargando...",
                    "oPaginate": {
                        "sFirst":    "Primero",
                        "sLast":     "Último",
                        "sNext":     "Siguiente",
                        "sPrevious": "Anterior"
                    },
                }
            });

            /**
             * INPUT CURRENCY
             */
            $("input[data-type='currency']").on({
                keyup: function () {
                    formatCurrency($(this));
                },
                focus: function () {
                    formatCurrency($(this), "blur");
                }
            });

            /**
             * INPUT MASK
             */
                // $('.amountInputMask').inputmask('currency', {
                //     allowPlus: false,
                //     allowMinus: false,
                //     rightAlign: true,
                //     groupSeparator: '.',
                //     numericInput: false,
                //     radixPoint: ',',
                //     digits: 2,
                //     prefix: '',
                //     unmaskAsNumber: true
                // });



            // ── Switchery — init centralizado ───────────────────────────────
            var SW_CONFIG = {
                    color    : '#4099ff',
                    jackColor: '#fff',
                    size     : 'small',
                    className: 'switchery floatright'
                };

            window.initSwitchery = function(container) {
                var elems = $(container || document).find('.siw-js-single:visible');
                elems.each(function () {
                    var el = this;
                    var next = el.nextElementSibling;
                    if (next && next.classList.contains('switchery')) {
                        next.remove();
                    }
                    el.style.display = '';  // ← fix: reset antes de re-inicializar
                    new Switchery(el, SW_CONFIG);
                });
            }

            // Init en carga de página — :visible excluye checkboxes dentro de modales cerrados
            window.initSwitchery();




        }
        catch (e) {
            console.warn('[switchery init]', e);
        }

        // Re-init en cada apertura de modal — pick up el checked state actualizado
        // Fuera del try/catch de arriba para que un fallo en otra inicialización no impida este registro
        $(document).on('shown.bs.modal', '.modal', function () {
            window.initSwitchery(this);
        });






    }

    function formatCurrency(input, blur) {

        let input_val = input.val();

        if (input_val === "") { return; }

        let original_len = input_val.length;

        let caret_pos = input.prop("selectionStart");

        if (input_val.indexOf(",") >= 0) {

            let decimal_pos = input_val.indexOf(",");

            let left_side = input_val.substring(0, decimal_pos);
            let right_side = input_val.substring(decimal_pos);

            left_side = formatNumber(left_side);

            right_side = formatNumber(right_side);

            right_side = right_side.substring(0, 2);

            input_val = left_side + "," + right_side;

        } else {

            input_val = formatNumber(input_val);

        }

        // send updated string to input
        input.val(input_val);

        let updated_len = input_val.length;
        caret_pos = updated_len - original_len + caret_pos;
        input[0].setSelectionRange(caret_pos, caret_pos);

    }

    function formatNumber(n) {
        // format number 1000000 to 1,234,567
        return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }

    /** ************************************************************************************
     *
     * INIT CONTROLLERS
     */

    function InitFunctionsController() {

        $('form input.form-control').keypress(function(e){
            if ( e.which === 13 ) return false;
            if ( e.which === 13 ) e.preventDefault();
        });

    }


    init();

})(jQuery)
